/**
 * Where the client looks for the server.
 *
 * Inside Discord the Activity is served through a proxy that prefixes every request
 * with /.proxy, and outside it the same build is served from the site root. Working
 * the prefix out from the page's own URL means one build serves both, and there is
 * no environment variable to get wrong at deploy time.
 */

const PROXY_PREFIX = '/.proxy';

/** True when the page is running inside the Discord client. */
export function isEmbedded(): boolean {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return (
    params.has('frame_id') ||
    window.location.hostname.endsWith('.discordsays.com') ||
    window.location.pathname.startsWith(PROXY_PREFIX)
  );
}

function prefix(): string {
  if (typeof window === 'undefined') return '';
  // Discord's proxy serves the Activity under /.proxy, so every request the page
  // makes has to carry the same prefix or it leaves the sandbox.
  return isEmbedded() ? PROXY_PREFIX : '';
}

const configuredOrigin = (import.meta.env.VITE_SERVER_ORIGIN ?? '').replace(/\/$/, '');

export function apiUrl(path: string): string {
  const base = configuredOrigin || window.location.origin;
  return `${base}${prefix()}${path}`;
}

export function socketUrl(): string {
  const base = configuredOrigin || window.location.origin;
  const url = new URL(`${base}${prefix()}/ws`);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  return url.toString();
}
